import { createBrowserRouter, RouterProvider, createRoutesFromElements, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Press from './components/Press';
import Staking from './pages/Staking';
import Referral from './pages/Referral';
import FAQ from './pages/FAQ';
import Tokenomics from './pages/Tokenomics';
import Roadmap from './pages/Roadmap';
import Layer2 from './pages/Layer2';
import QuantumGenesisStorySlider from './components/QuantumGenesisStorySlider';
import LogoScroll from './components/LogoScroll';
import QuantumThreats from './pages/QuantumThreats';
import AirdropInfo from './components/AirdropInfo';
import Footer from './components/Footer';
import NetworkModal from './components/NetworkModal';
import SolanaWalletModal from './components/SolanaWalletModal';
import TransactionPopup from './components/TransactionPopup';
import { useVisitorTracking } from './hooks/useVisitorTracking';
import PriceEstimator from './components/PriceEstimator';

const sections = [
  { id: 'home', Component: Home },
  { id: 'press', Component: Press },
  { id: 'slider', Component: QuantumGenesisStorySlider },
  { id: 'staking', Component: Staking },
  { id: 'tokenomics', Component: Tokenomics },
  { id: 'roadmap', Component: Roadmap },
  { id: 'layer2', Component: Layer2 },
  { id: 'logos', Component: LogoScroll },  
  { id: 'referral', Component: Referral },
  { id: 'threats', Component: QuantumThreats },
  { id: 'airdrop', Component: AirdropInfo },
  { id: 'faq', Component: FAQ }
];

// Create MainLayout component to hold the structure
function MainLayout() {
  return (
    <div className="min-h-screen text-quantum-light">
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-radial from-quantum-primary/10 via-transparent to-transparent opacity-30" />
        <div className="absolute inset-0 bg-gradient-radial from-quantum-secondary/10 via-transparent to-transparent opacity-30" 
              style={{ transform: 'translate(50%, 50%)' }} />
      </div>
      
      <div className="relative z-10 min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          {sections.map(({ id, Component }, index) => (
            <section 
              key={id} 
              id={id} 
              className={`${
                index === 0 ? 'pb-0' : 
                index === 1 ? 'py-0' : 
                id === 'price-estimator' ? 'py-16 container mx-auto' :
                'py-10 md:py-8'
              }`}
            >
              <Component />
            </section>
          ))}
        </main>
        <Footer />
        <NetworkModal />
        <SolanaWalletModal />
        <TransactionPopup />
      </div>
    </div>
  );
}

// Configure router with future flags
const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<MainLayout />} />
    </>
  ),
  {
    future: {
      // Remove the deprecated flags
    }
  }
);

function App() {
  useVisitorTracking();

  return <RouterProvider router={router} />;
}

export default App;